<template>
  <div class="account">
    <div class="account-bg"></div>
    <div class="account-logo"></div>
    <custom-input type="mobile" class="login-mobile" rules="mobile" placeholder="请输入手机号" @validate="handleValid" v-model="mobile"></custom-input>
    <custom-input type="password" class="login-password" rules="password" @validate="handleValid" v-model="password"></custom-input>
    <div class="login-links f-cb">
      <div class="login-save"><div class="login-save-check"></div>下次自动登录</div>
      <div class="login-forget" @click="forget_url">忘记密码？</div>
    </div>
    <div class="account-button" @click="login">账号登录</div>
    <div class="wechat_login" style="overflow: hidden;" v-show="isWeixin">
      <a :href="wx_url" style="display:block;">
        <img src="./wechat.png" alt="" style="width: 0.9rem;float:left;margin: 0.14rem 0.14rem 0 33%;"><span
        style="display: inline-block;float: left;">微信登录</span>
      </a>
    </div>
    <div class="login-register">还没有账号？<span @click="$router.push('/register')">去注册 ></span></div>
    <account-dialog :isOpen="isDialogShow" @close="isDialogShow=false" :textArr="error"></account-dialog>
  </div>
</template>
<script>
  import {dtCheck} from "../../util/dt-checkbox";
  import { JSEncrypt } from 'jsencrypt';
  import  $  from 'jquery';
  import {dtDialog} from "../../util/dialog";

  export default {
    name: "login",
    data(){
      return {
        check:null,
        error:[],
        isDialogShow:false,
        mobile:"",
        password:"",
        isWeixin: true,
        wx_url : 'javascript:;',
        v_key : this.$api.geturl_j1('v_key'),
        pwd_public_key:'-----BEGIN PUBLIC KEY-----\n' +
          'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1ei9lsraicRarKVzFX8c\n' +
          'gEHRi2lwdupu/q9gJP2TUCFa+Gx5+fmcxZmCfDBJFweSFiRlxMQbBWSv686jeRmz\n' +
          'inK/zj8OhUdN7NHrjojDHu7atyK3ZzL+nHs4l4y2rFdeAPRkSr4RavfjLksh4H/k\n' +
          'w7exAMkfJ/OR5Xjt9Izc5YYl6HNmPv4hwDF114N96Ns1HrTgCOsLOiG0VA8z47v/\n' +
          'iZt864XBKg33SVzh7A4PL6N6Yiwj9m1ag6iJqZjYgcaK0oFZjUk8OY9a9S4seGTG\n' +
          'fp71jcW0+gDJ8EG0phadxp0AxCWzCay0MCjhry7y2P//49fjbmWWlnj1OIB06E3f\n' +
          'jwIDAQAB\n' +
          '-----END PUBLIC KEY-----',
      }
    },
    methods:{
      iswx() {
        var ua = navigator.userAgent.toLowerCase();
        var wechat = ua.indexOf('micromessenger') != -1;
        if (wechat) {
          this.isWeixin = true;
        } else {
          this.isWeixin = false;
        }
      },
      login(){
        var that = this;
        //遍历所有子组件，验证其中的custom-input组件
        this.error=[];
        this.$children.forEach((value,index)=>{
          if(value.$options.name=="custom-input"){
            value.validate();
          }
        })
        var encrypt = new JSEncrypt();
        encrypt.setPublicKey(that.pwd_public_key);
        var timestamp = (Date.parse(new Date()) / 1000).toString();
        var dat = {
          user_login: that.mobile,
          user_pass: that.password,
          mode:1,
          timestamp:timestamp
        };
        dat = JSON.stringify(dat);
        var sendData = encrypt.encrypt(dat);
        console.log(that.v_key)
        if(this.error.length>0){
          this.isDialogShow=true;
        }
        else{
          $.ajax({
            url: '/api/proxy/index',
            data: {
              api:'/api/proxy/platform_login',
              data:sendData,
              v_key:that.v_key,
            },
            dataType: 'json',
            type: 'post',
            success:function(res){
              if(res.status===1){
                that.$toast("登录成功！");
                that.$store.commit("setLogin",1);
                // that.$store.commit("setMyid",res.data.id);
                // that.$store.commit("setMygroupIds",res.data.groupIds);
                that.tools.setStorage('mooc_user_token',res.data.data.user_token,res.data.data.expire_time);
                that.tools.setStorage('mooc_user_id',res.data.data.mooc_user_id,res.data.data.expire_time);
                that.tools.setStorage('mooc_user_salt',res.data.data.salt,res.data.data.expire_time);
                that.tools.setStorage('center_id',res.data.data.center_id,res.data.data.expire_time);
                that.tools.setStorage('user_type',res.data.data.user_type,res.data.data.expire_time);
                that.tools.setStorage('center_key',res.data.data.center_key,res.data.data.expire_time);
                // window.setTimeout(()=>{
                //   // this.$router.push("/index");
                //   // this.$router.go(-1);
                //   if(document.referrer == '' || document.referrer.indexOf('register') != -1 || document.referrer.indexOf('recoverpwd') != -1||document.referrer.indexOf('http://passport2.chaoxing.com/')!=-1){
                //     that.$router.push("/index")
                //   }else {
                //     that.$router.go(-1);
                //   }
                // },1000);
                $.ajax({
                  url: '/api/proxy/index',
                  type:'get',
                  async: false,
                  data:{
                    'api':'/v1/my/index',
                    'user_type':1,
                    // v_key:geturl_j('v_key')
                  },
                  success: function(res){
                    // alert(JSON.stringify(res))
                    if(res.status == 1){
                      that.$store.commit("setMyid",res.data.id);
                      that.$store.commit("setMygroupIds",res.data.groupIds);
                      window.setTimeout(()=>{
                        // this.$router.push("/index");
                        // this.$router.go(-1);
                        if(document.referrer == '' || document.referrer.indexOf('register') != -1 || document.referrer.indexOf('recoverpwd') != -1||document.referrer.indexOf('//passport2.chaoxing.com/')!=-1 || document.referrer.indexOf('login') != -1){
                          that.$router.push("/index")
                        }else {
                          that.$router.go(-1);
                        }
                      },1000);
                    }else{
                      that.$store.commit("setMyid",0);
                      that.$store.commit("setMygroupIds",[]);
                    }
                  }

                });
              }else{
                that.$toast(res.msg);
              }
            }
          })
          // this.axios({
          //   url: '/api/proxy/index',
          //   data: qs.stringify({
          //     api:"/api/proxy/platform_login",
          //     data:sendData,
          //   }),
          //   method: "post",
          //   headers: {
          //     'Content-Type': "multipart/form-data"
          //   }
          // })
          //   .then((res) => {
          //     if(res.status===1){
          //       this.$toast("登录成功！");
          //       this.$store.commit("setLogin",1);
          //       window.setTimeout(()=>{
          //         // this.$router.push("/index");
          //         // this.$router.go(-1);
          //         if(document.referrer == '' || document.referrer.indexOf('register') != -1 || document.referrer.indexOf('recoverpwd') != -1||document.referrer.indexOf('http://passport2.chaoxing.com/')!=-1){
          //           this.$router.push("/index")
          //         }else {
          //           this.$router.go(-1);
          //         }
          //       },1000);
          //     }
          //   })
          // this.$api.post('',{
          //   // api:"/api/proxy/pass_login",
          //   api:"/api/proxy/platform_login",
          //   data:sendData,
          //   // user_pass:this.password,
          //   // user_login:this.mobile,
          //   // mode:1
          // },res=>{
          //   if(res.status===1){
          //     this.$toast("登录成功！");
          //     this.$store.commit("setLogin",1);
          //     window.setTimeout(()=>{
          //       // this.$router.push("/index");
          //       // this.$router.go(-1);
          //       if(document.referrer == '' || document.referrer.indexOf('register') != -1 || document.referrer.indexOf('recoverpwd') != -1||document.referrer.indexOf('http://passport2.chaoxing.com/')!=-1){
          //         this.$router.push("/index")
          //       }else {
          //         this.$router.go(-1);
          //       }
          //     },1000);
          //   }
          // })
        }
      },
      //获取导航参数
      geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
      handleValid(obj){
        if(!obj.result){
          this.error.push(obj.msg);
        }
      },
      forget_url(){
        window.location.href = 'http://passport2.chaoxing.com/pwd/getpwd?version=1&fid=-1&refer=' + encodeURIComponent(window.location.href);
      }
    },
    mounted(){
      //自定义复选框
      this.check=dtCheck({
        el:document.querySelector(".login-save-check"),
        className:"login-save-check-checked"
      });
      this.iswx();
      this.$api.get('',{
        api:"/api/proxy/wechat_login",
        v_key:this.geturl_j2('v_key'),
      },res=>{
        if(res.status===1){
          this.wx_url = res.data.url
        }
      })



    }
  }
</script>

<style scoped>
  div.login-mobile{
    margin-top:1.067rem;
  }
  .login-links{
    margin:0.533rem 0.4rem 0 0.4rem;
    font-size:0.373rem;
    line-height:0.373rem;
  }
  .login-save{
    float:left;
    color:#0c539b;
  }
  .login-save-check{
    display: inline-block;
    width:0.293rem;
    height:0.293rem;
    margin-right:0.147rem;
    border:1px solid #999;
    border-radius: 2px;
  }
  .login-save-check-checked{
    background:url("../../asset/img/account/selected.png") center center no-repeat;
    background-size:0.253rem;
  }
  .login-forget{
    float:right;
    color:#999;
  }
  .login-register{
    margin-top:3.6rem;
    text-align: center;
    color:#999;
  }
  .login-register span{
    color:#0c539b;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue